
import { generateSignedUrl } from "./generateSignedUrl";

export const generateSignedEndpoint = async (apiHost) => {
  try {
    if (!apiHost?.includes("https://")) {
      apiHost = "https:" + apiHost;
    }
    const url = new URL(`${apiHost}`);
    const signedUrl = await generateSignedUrl(url);
    return signedUrl;
  } catch (e) {
    console.log("ERROR GENERATING SIGNED URL: ", e);
    return "";
  }
};
